import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Dialog from '@mui/material/Dialog';
import TeamManager from './TeamManager';
import {AppCTX} from '../data/AppContext';
import SearchPlaces from './SearchPlaces';
import ListItemIcon from '@mui/material/ListItemIcon';
import GroupIcon from '@mui/icons-material/Groups';
import LogoutIcon from '@mui/icons-material/Logout';

export default function SearchAppBar() {
  const { logout } = React.useContext(AppCTX);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [showTeamManager, setShowTeamManager] = React.useState(false);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleTeamClick = () => {
    handleMenuClose();
    setShowTeamManager(true);
  };

  const handleCloseTeamManager = () => {
    setShowTeamManager(false);
  };

  const handleLogout = async () => {
    handleMenuClose();
    try {
      await logout();
      console.log('Logout successful');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <AppBar 
      position="static"
      sx={{
        background: 'linear-gradient(135deg, rgba(20,20,20,0.9) 0%, rgba(28,28,28,0.9) 60%, rgba(38,38,38,0.9) 100%)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
        px: 1,
        pt: 'max(0px, env(safe-area-inset-top))'
      }}
    >
      <Toolbar sx={{ padding: 0, minHeight: 56, gap: 1 }}>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          aria-controls={open ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleMenuClick}
          sx={{ 
            ml: 1.5, mr: 1.5,
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
            '&:hover': { background: 'rgba(255,255,255,0.12)' }
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'block' } }}>
          <SearchPlaces />
        </Box>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              bgcolor: 'rgba(24,24,24,0.95)',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)',
              boxShadow: '0 12px 32px rgba(0,0,0,0.35), 0 2px 8px rgba(0,0,0,0.25)',
              backdropFilter: 'blur(8px)',
              borderRadius: 2,
              '& .MuiMenuItem-root': {
                color: '#fff',
                '&:hover': {
                  bgcolor: '#222',
                },
              },
            },
          }}
        >
          <MenuItem onClick={handleTeamClick}>
            <ListItemIcon sx={{ color: '#90caf9', minWidth: 36 }}>
              <GroupIcon fontSize="small" />
            </ListItemIcon>
            Team
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon sx={{ color: '#f48fb1', minWidth: 36 }}>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
        <Dialog open={showTeamManager} onClose={handleCloseTeamManager} fullScreen TransitionComponent={undefined}>
          <TeamManager onClose={handleCloseTeamManager} />
        </Dialog>
      </Toolbar>
    </AppBar>
  );
}